import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBlueprintComponent } from './simple-icons-blueprint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBlueprintComponent ],
    exports:      [ SimpleIconsBlueprintComponent ],
    bootstrap:    []
})
export class SimpleIconsBlueprintModule {}
